import moment from 'moment';
import {
  BonusQuestionGameWeek,
  BonusQuestionMatch,
  ChampionshipCalendarGameWeek,
  ChampionshipClubsById,
  SelectOption,
} from './types';

/** "21/08 - 23/08" */
export const formatGameWeekRange = (gameWeek: BonusQuestionGameWeek) =>
  `${moment(gameWeek.startDate).format('DD/MM')} - ${moment(
    gameWeek.endDate,
  ).format('DD/MM')}`;

export const indexCalendarGameWeeksByNumber = (
  gameWeeks: ChampionshipCalendarGameWeek[],
): Record<number, {startDate: string; endDate: string}> =>
  gameWeeks.reduce(
    (
      byNumber: Record<number, {startDate: string; endDate: string}>,
      gameWeek,
    ) => {
      byNumber[gameWeek.gameWeekNumber] = {
        startDate: gameWeek.startDate,
        endDate: gameWeek.endDate,
      };
      return byNumber;
    },
    {},
  );

export const buildGameWeekOptions = (
  gameWeeks: BonusQuestionGameWeek[],
): SelectOption[] =>
  [...gameWeeks]
    .sort((a, b) => a.gameWeekNumber - b.gameWeekNumber)
    .filter(gameWeek => !gameWeek.cancelled)
    .filter(gameWeek => moment(gameWeek.startDate).isAfter(moment()))
    .map(gameWeek => ({
      value: gameWeek.gameWeekNumber,
      label: `Journée ${gameWeek.gameWeekNumber}`,
      hint: formatGameWeekRange(gameWeek),
      disabled: Boolean(gameWeek.hasBonusQuestion || gameWeek.bonusQuestionId),
    }));

export const buildMatchOptions = (
  matches: BonusQuestionMatch[],
  clubsById: ChampionshipClubsById = {},
): SelectOption[] =>
  [...matches]
    .sort((a, b) => moment(a.date).valueOf() - moment(b.date).valueOf())
    .reduce((options: SelectOption[], match) => {
      const matchId = match?.id;
      if (matchId === undefined) return options;

      const date = match?.date;
      options.push({
        value: matchId,
        label: `${clubsById[match.homeClubId || '']?.shortName} - ${clubsById[match.awayClubId || '']?.shortName} · ${matchId}`,
        hint: date ? moment(date).format('DD/MM HH:mm') : undefined,
      });
      return options;
    }, []);

/** Compte les emojis comme un seul caractère (approximation par code point). */
export const countCharacters = (value: string) =>
  Array.from(value || '').length;

export const truncateCharacters = (value: string, maxLength: number) =>
  Array.from(value || '')
    .slice(0, maxLength)
    .join('');

/** Entiers positifs uniquement (champ vide autorisé pendant la saisie). */
export const sanitizePositiveInteger = (value: string) =>
  (value || '').replace(/[^0-9]/g, '').replace(/^0+(?=\d)/, '');



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/QuestionBonus/utils.ts